import { ImageWarnings, WarningDefinitionData, Warnings } from "@nova/constants"
import { VideoState } from "./VideoSlice"
import { get } from "nodash"

export const videoWarningDefinitions: WarningDefinitionData = {
    MP4: {
        type: Warnings.Error,
        name: "Video File",
        successMessage: "An MP4 has been provided",
        successStatus: "Provided",
    },
    SRT: {
        type: Warnings.Error,
        name: "SRT File",
        successMessage: "An SRT file has been provided",
        successStatus: "Provided",
    },
    quantity: {
        type: Warnings.Error,
        name: "Quantity",
        successStatus: "The correct number of files have been uploaded",
        successMessage: "Correct",
    },
}

export const videoWarningProcessor = (uploads: VideoState[]) => {
    const warnings: ImageWarnings = {}
    if (uploads.length > 2) {
        warnings["quantity"] = {
            status: "Insufficient",
            warning: "Please upload only one MP4 and optionally one matching SRT file",
            type: Warnings.Error,
        }
    }
    if (!uploads.some((upload) => !(get(upload, "s3Key") || "").toLowerCase().includes(".mp4"))) {
        warnings["SRT"] = {
            status: "Missing",
            warning: "Processing without an SRT will not produce projection data",
            type: Warnings.Warning,
        }
    }
    if (!uploads.some((upload) => (get(upload, "s3Key") || "").toLowerCase().includes(".mp4"))) {
        warnings["MP4"] = {
            status: "Missing",
            warning: "Please upload an MP4 video",
            type: Warnings.Error,
        }
    }
    if (
        uploads.filter((upload) => (get(upload, "s3Key") || "").toLowerCase().includes(".mp4"))
            .length > 1
    ) {
        warnings["MP4"] = {
            status: "Too many",
            warning: "Only one MP4 can be processed at a time",
            type: Warnings.Error,
        }
    }

    return { warnings }
}
